export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6281.a8d57822.jpg";